module.exports = __webpack_public_path__ + "static/media/chat-m.9a33d2c4.svg";